import React, { useEffect, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";

import { ModalCultivoScreen } from "./ModalCultivoScreen";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import { useSelector } from "react-redux";

export const CultivoListScreen = ({ setLoading }) => {
  const { clienteselected, idcliente } = useSelector((store) => store.clientes);
  const [cultivos, setcultivos] = useState([]);
  const [registro, setregistro] = useState(-1);
  const openModal = (value) => {
    var modal = document.getElementById("modal-cultivo");
    modal.style.display = "block";
    setregistro(value);
  };
  useEffect(() => {
    if (
      idcliente === undefined ||
      idcliente === null ||
      idcliente === 0 ||
      idcliente === "0" ||
      idcliente === "" ||
      idcliente === "-1" ||
      idcliente === "-1"
    ) {
      return;
    }
    setLoading(true);
    request
      .get(`ClientesCultivo/Listado?idcliente=${Number(idcliente)}`)
      .then((result) => {
        setLoading(false);
        setcultivos(result);
      })
      .catch((error) => {
        setLoading(false);
        Swal.fire("Clientes", JSON.stringify(error), "error");
      });
  }, [idcliente]);
  if (
    idcliente === undefined ||
    idcliente === null ||
    idcliente === 0 ||
    idcliente === "0" ||
    idcliente === "" ||
    idcliente === "-1" ||
    idcliente === "-1"
  ) {
    return <div>Favor de seleccionar un cliente</div>;
  }
  const capitalizeWords = (str) => {
    return str ? str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase()) : "";
  };
  return (
    <>
      <div className="clientes-cultivo-header">
        <ModalCultivoScreen setcultivos={setcultivos} registro={registro} />
        <div className="clientes-cultivo-titulo">{capitalizeWords(clienteselected)}</div>
        <div className="clientes-cultivo-agregar" onClick={() => openModal(-1)}>
          Agregar
        </div>
      </div>
      <div className="clientes-cultivo-container scroll-4">
        {cultivos === undefined ||
        cultivos === null ||
        cultivos.length === 0 ? (
          <div className="no-data " xx>
            Sin datos registrados
          </div>
        ) : (
          <table cellPadding={0} cellSpacing={0}>
            <thead>
              <tr>
                <th>Cultivos</th>
                <th>Terreno</th>
                <th>Hectareas</th>
                <th>Tipo Riego</th>
                <th>Temporal</th>
                <th>Rendimiento (T/HA)</th>
                <th>Precio (Tonelada)</th>
                <th>Total</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {cultivos.map((item) => (
                <tr>
                  <td>{capitalizeWords(item.cultivo)}</td>
                  <td>{capitalizeWords(item.terreno)}</td>
                  <td>{item.hectareas}</td>
                  <td>{capitalizeWords(item.tipo_riego)}</td>
                  <td>{capitalizeWords(item.temporal)}</td>
                  <td>{FormatMoney(item.rendimiento)}</td>
                  <td>{FormatMoney(item.precio)}</td>
                  <td>
                    {FormatMoney(
                      Number(item.rendimiento) *
                        Number(item.precio) *
                        Number(item.hectareas)
                    )}
                  </td>
                  <td>
                    <div
                      className="button-editar"
                      onClick={() => openModal(item.registro)}
                    >
                      <EditIcon />
                      Editar
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </>
  );
};
